import styled from "styled-components";

export const HomePageWrapper = styled.div`
  padding-top: 220px;

  @media(max-width: 1440px) {
    padding-top: 210px;
  }

  @media(max-width: 1264px) {
    padding-top: 210px;
  }

  @media(max-width: 1024px) {
    padding-top: 167px;
  }

  @media(max-width: 768px){
    padding-top: 20px;
  }

  @media(max-width: 431px) {
    padding-top: 201px;
  }
`;

export const HomeSlideContainer = styled.section`
  width: 100vw;
  position: relative;

  > img {
    max-height: 500px;
    width: 100%;
    object-fit: cover
  }
`;

export const HomeSlideInfosBox = styled.div`
  position: absolute;
  width: calc(100% - 160px);
  bottom: 40px;
  max-width: 768px;
  left: 160px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  > span {
    font-size: 48px;
    font-weight: 700;
    line-height: 57px;
    color: #fff;
  }
  @media (max-width: 960px) {
    left: 40px;
    bottom: 20px;
    width: calc(100% - 80px);
    > span {
      font-size: 32px;
      line-height: 40px;
    }
  }
`;

export const HomeSlideTheme = styled.div`
  width: fit-content;
  background: #2786bd;
  color: #fff;
  padding: 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 42px;
`;

export const CheckMoreButton = styled.a`
  padding: 16px 24px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #0a5079 !important;
  width: fit-content;
  gap: 8px;
  cursor: pointer;
  &:hover {
    background: #eef8ff;
  }
`;

export const HomeSectionTitle = styled.h1`
  font-size: 48px;
  color: #0a5079;
  font-weight: 500;
  margin-bottom: 16px;

  > hr {
    width: 115px;
    height: 2px;
    background: #2786bd;
    margin: 0px;
    margin-top: 8px;
  }
`;

export const PageSection = styled.section`
  padding: 40px 160px 0px 160px;

  @media (max-width: 960px) {
    padding: 40px;
  }
`;

export const CheckAllItems = styled.button`
  border: 1px solid #2786bd;
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2786bd;
  background: none;
  margin: 48px auto;
  font-size: 16px;
  font-weight: 500;

  &:hover {
    cursor: pointer;
    background: #278cbd;
    color: #fff;
  }
`;

export const HomeBanner = styled.img`
  width: 100%;
  min-height: 400px;
  background-size: cover;
  object-fit: cover;
`;

export const NewsTitle = styled.h1`
  color: #0a5079;
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
  margin: 0px;
`;

export const NewsDescription = styled.span`
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  color: #1b1b1b;
`;

export const CheckAllNewsButton = styled.button`
  background: none;
  font-size: 16px;
  font-weight: 600;
  color: #0a5079;
  border: 1px solid #0a5079;
  padding: 16px 24px;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #0a5079;
    color: #fff;
  }
`;

export const CheckNewsDetails = styled.button`
  background: #0a5079;
  color: #fff;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  border: none;

  &:hover {
    cursor: pointer;
    background: #023857;
  }
`;

export const NewsImage = styled.img`
  width: 100%;
  border-radius: 8px;
  height: 100%;
  background-size: contain;
  object-fit: cover;
  max-height: 400px;
`;

interface IPaginationNumber {
  isActive?: boolean;
}

export const PaginationNumber = styled.span<IPaginationNumber>`
  font-size: 40px;
  font-weight: 500;
  color: ${(props) => (props.isActive ? "#2786BD" : "#808080")};
`;

export const PaginationButton = styled.button`
  background: none;
  border: none;
  height: 40px;
  width: 40px;
  cursor: pointer;

  &:disabled {
    path {
      stroke: #2d9d853d !important;
    }
  }
`;
